import {
  FirstQuiz,
  Ringstar,
  ConsistantPlayer,
  Places,
  QuizPro,
  PerfectRound,
  CategorySpecialist,
  ReflectiveThinker,
  MasterOfGoals,
  SeasonChallenger,
  HighScorer,
  MilestoneCollector,
  PeacefulGarden,
  WeelnessIsland,
  MountainPark,
  HealthyMarket,
  FitArena,
  MindfulnessRetreat,
  SunriseBaby,
  OasisTemple,
} from "@utils/defaultImages";

export const sliderData = [
  {
    RankImage: FirstQuiz,
    title: "First Quiz",
    unlockDate: "Unlocked on 5th July",
    description: "Achieved by completing your very first quiz.",
  },
  {
    RankImage: Ringstar,
    title: "Rising Star",
    unlockDate: "Unlocked on 5th July",
    description: "Achieved when you reach 100 total points across quizzes.",
  },
  {
    RankImage: ConsistantPlayer,
    title: "Consistent Player",
    unlockDate: "Unlocked on 5th July",
    description: " Achieved after you complete 5 quizzes.",
  },
  {
    RankImage: QuizPro,
    title: "Quiz Pro",
    unlockDate: "Unlocked on 5th July",
    description: "Achieved after you complete 10 quizzes.",
  },
  {
    RankImage: PerfectRound,
    title: "Perfect Round",
    unlockDate: "Unlocked on 5th July",
    description: "Achieved when you score 100% on a full quiz.",
  },
  {
    RankImage: CategorySpecialist,
    title: "Category Specialist",
    unlockDate: "Unlocked on 5th July",
    description:
      "Achieved after completing 5 quizzes in the same goal category.",
  },
  // {
  //   RankImage: ReflectiveThinker,
  //   title: "Reflective Thinker",
  //   unlockDate: "Unlocked on 5th July",
  //   description:
  //     "Achieved after completing a set number of reflective/emotional prompts.",
  // },
  {
    RankImage: MasterOfGoals,
    title: "Master of Goals",
    unlockDate: "Unlocked on 5th July",
    description:
      "Achieved when you reach a major points milestone (e.g., 10,000 points) or multiple category specialist badges.",
  },
  // {
  //   RankImage: SeasonChallenger,
  //   title: "Seasonal Challenger",
  //   unlockDate: "Unlocked on 5th July",
  //   description: "Achieved by finishing a seasonal or holiday-themed quiz.",
  // },
  {
    RankImage: HighScorer,
    title: "High Scorer",
    unlockDate: "Unlocked on 5th July",
    description:
      "Achieved when you score above the high-score threshold (e.g., 90+) on a quiz.",
  },
  {
    RankImage: MilestoneCollector,
    title: "Milestone Collector",
    unlockDate: "Unlocked on 5th July",
    description:
      "Achieved when you have earned a specified number of badges (e.g., 5 badges).",
  },
];

export const placesSliderData = [
  {
    RankImage: PeacefulGarden,
    title: "The Peaceful Garden",
    unlockDate: "Unlocked on 5th July",
    description:
      "Achieved by earning your first stress-reduction badge or completing 5 stress-focused quizzes.",
  },
  {
    RankImage: WeelnessIsland,
    title: "Wellness Island",
    unlockDate: "Unlocked on 5th July",
    description:
      "Achieved when you reach 200 total points across the quiz game.",
  },
  {
    RankImage: MountainPark,
    title: "Mountain Peak",
    unlockDate: "Unlocked on 5th July",
    description:
      "Achieved after earning the “High Scorer” badge or passing a high-point threshold.",
  },
  {
    RankImage: HealthyMarket,
    title: "Healthy Market",
    unlockDate: "Unlocked on 5th July",
    description:
      " Achieved by completing several Nutrition-category quizzes (becoming a Category Specialist in Nutrition).",
  },
  {
    RankImage: FitArena,
    title: "Fit Arena",
    unlockDate: "Unlocked on 5th July",
    description:
      "Achieved after multiple Moving/Exercise quizzes or by completing 3 timed challenges.",
  },
  {
    RankImage: MindfulnessRetreat,
    title: "Mindful Retreat",
    unlockDate: "Unlocked on 5th July",
    description:
      "Achieved by earning multiple Reflective Thinker badges or finishing several mindfulness quizzes.",
  },
  // {
  //   RankImage: SunriseBaby,
  //   title: "Sunrise Bay",
  //   unlockDate: "Unlocked on 5th July",
  //   description:
  //     "Achieved by participating in and completing a seasonal challenge or themed quiz.",
  // },
  {
    RankImage: OasisTemple,
    title: "Oasis Temple",
    unlockDate: "Unlocked on 5th July",
    description:
      "Achieved when you achieve a major long-term milestone (e.g., 10,000 points or the “Master of Goals” badge).",
  },
];
